export default "__VITE_ASSET__BT7tyMN7__"